import { usePageSEO } from '@/hooks/usePageSEO';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import Problemes from './components/Problemes';
import Urgence from './components/Urgence';
import Prix from './components/Prix';
import Process from './components/Process';
import Temoignage from './components/Temoignage';
import FAQ from './components/FAQ';
import QuoteForm from './components/QuoteForm';
import EmergencyBar from './components/EmergencyBar';
import CTAFinal from './components/CTAFinal';

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: 'Accueil', item: 'https://couvreur-levis.com/' },
    { '@type': 'ListItem', position: 2, name: 'Réparation toiture', item: 'https://couvreur-levis.com/reparation-toiture-levis' },
  ],
};

const serviceSchema = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  serviceType: 'Réparation de toiture',
  provider: { '@type': 'LocalBusiness', '@id': 'https://couvreur-levis.com/#business' },
  areaServed: { '@type': 'City', name: 'Lévis' },
  description: "Réparation de toiture à Lévis. Infiltration d'eau, urgence 7j/7, intervention sous 24h. Couvreurs partenaires RBQ.",
  offers: {
    '@type': 'AggregateOffer',
    priceCurrency: 'CAD',
    lowPrice: '350',
    highPrice: '6000',
    offerCount: '4',
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'Combien de temps avant que vous interveniez ?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: "Pour les urgences actives (eau qui coule), on intervient sous 24h ouvrables. Pour les réparations non urgentes, l'inspection est généralement faite sous 48h. On vous donne un horaire précis dès l'appel.",
      },
    },
    {
      '@type': 'Question',
      name: 'Travaillez-vous en hiver pour les urgences ?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: "Oui, absolument. On fait des réparations d'urgence 12 mois par année. En hiver, on utilise des matériaux conçus pour le froid et on pose des bâches temporaires si nécessaire en attendant des conditions meilleures.",
      },
    },
    {
      '@type': 'Question',
      name: 'Mon assurance couvre-t-elle la réparation ?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: "Si la réparation est causée par un événement couvert (tempête, grêle, vent violent), votre assurance couvre généralement les dommages. On vous aide à préparer le dossier avec un rapport photo détaillé et une attestation de notre couvreur.",
      },
    },
    {
      '@type': 'Question',
      name: 'Pouvez-vous poser une bâche temporaire en attendant ?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: "Oui, c'est souvent notre première étape en cas d'urgence. Une bâche d'étanchéité professionnelle protège votre toit jusqu'à la réparation définitive. C'est rapide, efficace, et inclus dans notre plan d'urgence.",
      },
    },
    {
      '@type': 'Question',
      name: 'Une réparation est-elle garantie ?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: "Toutes nos réparations sont couvertes par une garantie écrite de 3 à 5 ans selon le type de travail. Si le même problème réapparaît à cause d'un défaut de notre part, on revient réparer sans frais.",
      },
    },
  ],
};

export default function ReparationPage() {
  usePageSEO({
    title: 'Réparation toiture Lévis | Urgence 7j/7 | Infiltration',
    description: "Réparation de toiture à Lévis. Infiltration d'eau, urgence 7j/7, intervention sous 24h. Soumission gratuite. Appelez le 418-476-9950.",
    urlPath: '/reparation-toiture-levis',
    keywords: 'réparation toiture Lévis, infiltration eau, fuite toiture, urgence toiture, couvreur',
    ogImage: '/og/og-reparation-toiture-levis.jpg',
    ogImageAlt: 'Réparation toiture Lévis - Urgence 7j/7 intervention 24h',
    jsonLdSchema: [breadcrumbSchema, serviceSchema, faqSchema],
  });

  return (
    <div className="font-inter min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <Problemes />
        <Urgence />
        <Prix />
        <Process />
        <Temoignage />
        <FAQ />
        <QuoteForm />
        <EmergencyBar />
        <CTAFinal />
      </main>
      <Footer />
    </div>
  );
}